export default __webpack_public_path__ + "static/media/component-126-11@2x.a38ac432.png";